import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
//import axios from "axios";
import { axiosinstance } from './axiosconfig';

export const fetchMemberInfoByPersId = createAsyncThunk('fetchMemberInfoByPersId', async (arg) => {
    try {
        let res = await axiosinstance.get(
            `/pagebookdate/querymemberinfo/persid/${arg.pers_id}`
        );
        return (res.data);
    } catch (err) {
        console.log('MemberInfoSlice fetchMemberInfoByPersId -> error : ', err);
    };
});

/*-----------------------------------------------------------------------------*/
export const fetchMemberInfoByName = createAsyncThunk('fetchMemberInfoByName', async (arg) => {
    try {
        let res = await axiosinstance.get(
            `/pagebookdate/querymemberinfo/persname/${arg.pers_name}`
        );
        return (res.data);
    } catch (err) {
        console.log('MemberInfoSlice fetchMemberInfoByName -> error : ', err);
    };
});

/*---------------------------- fetchAllMemberInfoByName : added on 13-09-2024 ----------------------------*/
export const fetchAllMemberInfoByName = createAsyncThunk('fetchAllMemberInfoByName', async (persname) => {
    // console.log('fetchAllMemberInfoByName ---> ', persname)
    try {
        let res = await axiosinstance.get(
            `/pagebookdate/queryallmemberinfo/persname/${persname}`
        );
        return (res.data);
    } catch (err) {
        console.log('MemberInfoSlice fetchAllMemberInfoByName -> error : ', err);
    };
});
/*----------------------------------------------------------------------------------------------------------*/

export const fetchMemberInfoByUserType = createAsyncThunk('fetchMemberInfoByUserType', async (usertype) => {
    try {
        let res = await axiosinstance.get(
            `/pagebookdate/queryMemberInfoByUsrType/usertype/${usertype}`
        );
        return (res.data);
    } catch (err) {
        console.log('MemberInfoSlice fetchMemberInfoByPosition -> error : ', err);
    }
});

/*------------------ addNewMember added on 04-04-2024 --------------------------*/
export const addNewMember = createAsyncThunk('addNewMember', async (new_memberlist) => {
    try {
        let res = await axiosinstance.put(
            `/pagebookdate/addnewmember`,
            { new_memberlist }
        );
        // console.log('MemberInfoSlice ---> addNewMember :: ', res);
        return res;
    } catch (err) {
        console.log('MemberInfoSlice : addNewMember -> error : ', err);
        return err['code'];
    }
})

export const memberInfoSlice = createSlice({
    name: 'memberinfo', //slice or store name  memberinfo.meminfoarr
    initialState: {
        meminfoarr: null,
        memallinfoarr: null,
        meminfobyusrtype: null,
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchMemberInfoByPersId.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchMemberInfoByPersId.fulfilled, (state, action) => {
            state.isLoading = false;
            state.meminfoarr = action.payload;
        })
        builder.addCase(fetchMemberInfoByPersId.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })

        builder.addCase(fetchMemberInfoByName.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchMemberInfoByName.fulfilled, (state, action) => {
            state.isLoading = false;
            state.meminfoarr = action.payload;
        })
        builder.addCase(fetchMemberInfoByName.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })

        /*-------------------------- fetchAllMemberInfoByName : added on 13-09-2024 -----------------*/

        builder.addCase(fetchAllMemberInfoByName.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchAllMemberInfoByName.fulfilled, (state, action) => {
            state.isLoading = false;
            state.memallinfoarr = action.payload;
        })
        builder.addCase(fetchAllMemberInfoByName.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })
        /*--------------------------------------------------------------------------------------------*/

        builder.addCase(fetchMemberInfoByUserType.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchMemberInfoByUserType.fulfilled, (state, action) => {
            state.isLoading = false;
            state.meminfobyusrtype = action.payload;
        })
        builder.addCase(fetchMemberInfoByUserType.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })

         /*------------------- addNewMember added on 04-04-2024 ---------*/
         builder.addCase(addNewMember.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(addNewMember.fulfilled, (state, action) => {
            state.isLoading = false;
            //console.log('MemberInfoSlice ---> addCase --> addNewMember :: ', action.payload);
        })
        builder.addCase(addNewMember.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })
    }
});//memberInfoSlice 

export default memberInfoSlice.reducer;
